import { imageQuillDTO } from './../custom-quill-base-class';
// Dependencies
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, OnInit, OnDestroy, Renderer2 } from '@angular/core';
// Services
import { LoggedUserStateService } from '@frontend/unhideschool/core/services/legacy/logged-user.state';
// Utils
import { CommentItemComponent } from '../comment-item/comment-item.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { filter, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@frontend/unhideschool/env';
import { RestApiService } from '@frontend/unhideschool/app/api-gateway/services/rest-api.service';

@Component({
  selector: 'unh-comments-container',
  templateUrl: './comments-container.component.html',
  styleUrls: ['./comments-container.component.scss']
})
export class CommentsContainerComponent implements OnInit, OnDestroy {
  isMobile = false;
  private readonly destroy$ = new Subject();

  private comments$ = new BehaviorSubject([]);

  @Input() creator: any;

  @Input()
  set comments(comments) {
    this.comments$.next(comments);
  }
  get comments(): any[] {
    return this.comments$.getValue();
  }

  @Input() currentMobileState = false;
  @Input() showLoadmore = false;
  @Input() defaultAvatarUrl: string = environment.defaultAvatarUrl;
  @Input() badges: any[];

  @Output() mobileBoxStateChanged = new EventEmitter();
  @Output() commentSubmitted = new EventEmitter<{ value: any, images: any[] }>();
  @Output() fetchMoreComments = new EventEmitter<any>();

  @ContentChild('commentTemplate', { static: false })

  commentTemplateRef: TemplateRef<CommentItemComponent>;
  images: imageQuillDTO[];
  commentInnerHtml = null;
  commentImages = [];
  submitDisabled = true;
  userAvatarUrl = '';
  quillEditor;

  constructor(
    public luss: LoggedUserStateService,
    private breakpointObserver: BreakpointObserver,
    private rest: RestApiService,
    private ar: ActivatedRoute,
    private renderer: Renderer2
  ) { }

  ngOnDestroy(): void {
    this.destroy$.next({});
    this.destroy$.complete();
  }

  ngOnInit() {
    this.userAvatarUrl = this.luss.getProfilePicture();

    this.breakpointObserver
      .observe('(max-width: 992px)')
      .pipe(takeUntil(this.destroy$))
      .subscribe((bo) => (this.isMobile = bo.matches));
  }

  ngAfterViewInit() {
    this.comments$.subscribe(comments => {
      if (comments != undefined && comments.length > 0) {
        const index = comments.findIndex(comment => comment.commentid == this.ar.snapshot.queryParams._c);
        if (index >= 0) {
          this.scrollToComment();
        } else {
          comments.forEach((comment: any) => {
            const index = comment.replies.findIndex(reply => reply.commentid == this.ar.snapshot.queryParams._c);
            if (index >= 0) {
              this.scrollToComment();
            }
          })
        }
      }
    })
  }

  trackByFn = (index, comment) => comment.commentid;

  toggleContainerState() {
    this.currentMobileState = !this.currentMobileState;
    this.mobileBoxStateChanged.emit(this.currentMobileState);
  }

  submitComment() {
    const uploadedImages = [];

    let count = 0;
    if (this.commentImages.length > 0) {
      this.commentImages.forEach(image => {
        const data = new FormData();
        data.append('file', image.file, image.file.name);
        data.append('mediacontenttype', 'communitymediaitem');
        this.rest.upload('/media/uploadfile', data).pipe(
          filter(res => res.status === 'complete')
        ).subscribe(res => {
          if (res.status === 'complete') {
            count++;
            const uploadedImage = {
              id: res.message.dict.fileid,
              url: res.message.dict.urlimage
            };
            uploadedImages.push(uploadedImage);
            this.commentInnerHtml = this.commentInnerHtml.replace(image.blobUrl, uploadedImage.url);
            if (count == this.commentImages.length) {
              this.commentSubmitted.emit({ value: this.commentInnerHtml, images: uploadedImages });
              this.commentInnerHtml = null;
              this.quillEditor.setText('');
            }
          }
        })
      })
    } else {
      this.commentSubmitted.emit({ value: this.commentInnerHtml, images: this.images });
      this.commentInnerHtml = null;
      this.quillEditor.setText('');
    }
  }

  submitFetchMoreComments() {
    this.fetchMoreComments.emit();
  }

  onTextChanged(e) {
    if (e.event === "text-change") {
      this.commentInnerHtml = e.html;
      if ((e.text.match(/[^\s]/) || this.commentImages.length > 0)) {
        this.submitDisabled = false;
      } else {
        this.submitDisabled = true;
        if (this.commentInnerHtml && this.commentInnerHtml.includes('iframe')) {
          this.submitDisabled = false;
        }
      }
    }
  }

  onImagesChanged(images) {
    this.commentImages = images;
    if (this.commentImages && this.commentImages.length > 0) {
      this.submitDisabled = false;
    }
  }

  getQuillInstance(quillInstance) {
    this.quillEditor = quillInstance;
  }

  scrollToComment() {
    const scrollintoview = () => {
      const addhighlight = () => {
        this.renderer.addClass(el, 'onfocus');
        setTimeout(() => {
          this.renderer.removeClass(el, 'onfocus');
        }, 1000)
      }
      const el = document.querySelector(`#c${this.ar.snapshot.queryParams._c}`);
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });

      setTimeout(addhighlight, 100);
    }

    setTimeout(scrollintoview, 200);
  }
}



